import { apiCall } from "./auth";
import { API_URL } from "./config";



export const getGrassyByKeyword = (data, event) => {
    let keyword = data.params.keyword;
    return apiCall(`${API_URL}grassy/getGrassy?keyword=${keyword}`, "GET", data, event);
}

export const getGrassyById = (data) => apiCall(`${API_URL}grassy/getGrassyById`, "POST", data);
